import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { ModalOutlet } from '~/application/outlet/ModalOutlet';

const DeletePage = lazy(() => import('./pages/delete'));
const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/purchase-orders',
    title: 'Narudžbe dobavljaču',
    Component: IndexPage,
    children: [{
        path: ':orderId',
        Component: ModalOutlet,
        children: [{
            path: 'delete',
            Component: DeletePage,
        }],
    }],
} satisfies RouteObject;
